import { Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { WhatsAppChatComponent } from '../chat/whatsapp-chat.component';

/**
 * Abre el chat de WhatsApp en un diálogo. Centraliza la configuración del diálogo, que hasta ahora
 * estaba copiada en cada componente que lo abría y ya había empezado a divergir.
 */
@Injectable({
  providedIn: 'root'
})
export class WhatsappChatService {

  constructor(private dialogService: DialogService) { }

  open(phoneNumber: string, name?: string, caseId?: string) {
    this.dialogService.open(WhatsAppChatComponent, {
      closable: true,
      header: 'Whatsapp ' + phoneNumber + (name ? ' - ' + name : ''),
      width: '800px',
      draggable: true,
      modal: false,
      data: {
        caseId: caseId,
        phoneNumber: phoneNumber,
        name: name
      }
    });
  }

}
